import { CriteriaDimension, SortDirection } from '@openx/types/tableCriteria.ts';
import { TABLE_PAGE_SIZE } from '../../../../config.ts';

export const defaultCriteria = {
  [CriteriaDimension.FILTERS]: { phrase: '' },
  [CriteriaDimension.SORT]: {
    column: 'name',
    direction: SortDirection.ASC,
    sortableColumns: ['name', 'created_date', 'modified_date'],
  },
  [CriteriaDimension.PAGINATION]: { pageNumber: 1, pageSize: TABLE_PAGE_SIZE, totalCount: 0, hasMore: false },
};
